import axios from "axios";
import { toast as message } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetFaxNumberSubscriptions = () => async (dispatch) => {
  dispatch({ type: "GET_FAX_SUBSCRIPTIONS_LOADER", payload: true });
  try {
    const res = await axios.get(`${BASE_URL}/subscription/fax-subscriptions`, {
      headers: { Authorization: localStorage.getItem("authToken") },
    });
    const data = res.data?.result?.data?.data ?? [];
    dispatch({ type: "GET_FAX_SUBSCRIPTIONS_DATA", payload: data });
    return data;
  } catch (error) {
    message.error("Failed to load fax subscriptions.");
    return [];
  } finally {
    dispatch({ type: "GET_FAX_SUBSCRIPTIONS_LOADER", payload: false });
  }
};

export const actionCreateFaxSubscriptions = (subscriptionData) => async (dispatch) => {
  dispatch({ type: "CREATE_FAX_SUBSCRIPTIONS_LOADER", payload: true });
  try {
    const res = await axios.post(
      `${BASE_URL}/subscription/create-fax-subscriptions`,
      subscriptionData,
      { headers: { Authorization: localStorage.getItem("authToken") } }
    );
    const result = res.data?.result?.data;
    dispatch({ type: "CREATE_FAX_SUBSCRIPTIONS_SUCCESS", payload: result });
    return result;
  } catch (error) {
    message.error("Failed to create fax subscriptions.");
    throw error;
  } finally {
    dispatch({ type: "CREATE_FAX_SUBSCRIPTIONS_LOADER", payload: false });
  }
};
